import React, { useRef } from "react";
import { BodyBuilder } from "../../exports/Images";

const CameraIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
    <circle cx="12" cy="13" r="4" />
  </svg>
);

const ProfileBanner = ({ userData, isEditing, onImageChange }) => {
  const fileInputRef = useRef(null);
  const name = userData?.name || "John Doe";
  const email = userData?.email || "john@wtfgyms.com";
  const profileImg = userData?.profile || BodyBuilder;
  const role = userData?.role || "Admin";
  const department = userData?.department || "Operations";
  const memberSince = userData?.createdAt
    ? new Date(userData.createdAt).toLocaleDateString("en-US", {
        month: "long",
        year: "numeric",
      })
    : "January 2023";

  const handleAvatarClick = () => {
    if (isEditing && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file && onImageChange) {
      onImageChange(file);
    }
  };

  return (
    <div className="v2-prof-pg-banner">
      <div
        className={`v2-prof-pg-banner__avatar-wrapper${isEditing ? " v2-prof-pg-banner__avatar-wrapper--editable" : ""}`}
        onClick={handleAvatarClick}
      >
        <img
          src={profileImg}
          alt={name}
          className="v2-prof-pg-banner__avatar"
        />
        {isEditing && (
          <>
            <div className="v2-prof-pg-banner__avatar-overlay">
              <div className="v2-prof-pg-banner__avatar-overlay-icon">
                <CameraIcon />
                <span className="v2-prof-pg-banner__avatar-overlay-text">Change</span>
              </div>
            </div>
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              className="v2-prof-pg-banner__avatar-input"
              onChange={handleFileChange}
            />
          </>
        )}
      </div>
      <div className="v2-prof-pg-banner__details">
        <h2 className="v2-prof-pg-banner__name">{name}</h2>
        <p className="v2-prof-pg-banner__email">{email}</p>
        <div className="v2-prof-pg-banner__badges">
          <span className="v2-prof-pg-banner__badge v2-prof-pg-banner__badge--primary">
            {role}
          </span>
          <span className="v2-prof-pg-banner__badge v2-prof-pg-banner__badge--outline">
            {department}
          </span>
        </div>
        <p className="v2-prof-pg-banner__member-since">
          Member since {memberSince}
        </p>
      </div>
    </div>
  );
};

export default ProfileBanner;
